import { render, staticRenderFns } from "./join.page.vue?vue&type=template&id=9879344a&scoped=true&"
import script from "./join.page.vue?vue&type=script&lang=js&"
export * from "./join.page.vue?vue&type=script&lang=js&"
import style0 from "./join.page.vue?vue&type=style&index=0&id=9879344a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9879344a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VDivider,VForm})
